export const nouser = lists => {

  const actuallocale = window.academystatus.locale.replace('_', '-')

  return `
  <div id="AccessDenied">
    <div class="Overlay"></div>
    <div class="AccessDenied">
      <div class="NoUser">
        <p>
          You need to be logged in to access this area. 
          Please log in or register as a Welding Hub Partner. 
        </p>
        <div class="Options">
          <button 
            class="Login"
          >
            ${ __('Login') }
          </button>
          <button 
            class="Register"
          >
            ${ __('Register') }
          </button>
        </div>
      </div>
      <div class="Close"></div>
    </div>
  </div>
  `
}

export const isuser = data => {

  const actuallocale = window.academystatus.locale.replace('_', '-')

  return `
  <div id="AccessDenied">
    <div class="Overlay"></div>
    <div class="AccessDenied WeldingPartner_${ data.weldinghubstatus || 'no' }">
      <div class="ShouldRegister">
        <div class="Title">
          Restricted Access
        </div>
        <p>
          You don't have permission to access this area. 
          To explore exclusive content and unlock additional features, 
          register as a Welding Hub Partner.
        </p>          
        <div class="Title Small">
          Would you like to register as a Welding Hub Partner?
        </div>
        <label>
          <input 
            type="checkbox" 
            name="academy_partnersupport_askregister"
            class="AskRegister" 
            value="yes"
          />
          <span class="Legend">
            Yes, I want to register as a Welding Hub Partner.
          </span>
        </label>
        <button 
          class="ShouldRegister"
          disabled="disabled"
        >
          ${ __('Submit') }
        </button>
      </div>
      <div class="RequestingRegistry">
        <div class="Title">
          Requesting Welding Hub Registration
        </div>
        <p>
          Please wait while we process your application 
          to register as a Welding Hub Partner.
        </p>
      </div>
      <div class="RequestingRegistryError">
        <div class="Title">
          Registration Error
        </div>
        <p>
          Sorry, there was an error with your application, 
          please try again. 
        </p>
      </div>
      <div class="ShouldRegisterConfirmation">
        <div class="Title">
          Your application has been received.
        </div>
        <p>
          Once your application is approved, you'll receive a confirmation email 
          with instructions on how to access the Welding Hub.
        </p>
      </div>
      <div class="WaitingRegisterConfirmation">
        <div class="Title">
          Your application is still being processed.
        </div>
        <p>
          We're still reviewing your application. Once it's approved, you'll receive 
          a confirmation email with instructions on how to access the Welding Hub. 
        </p>
      </div>
      <div class="Close"></div>
    </div>
  </div>
  `
}